import React from 'react';
import {FormInput} from 'react-form';
import StarRatingComponent from 'react-star-rating-component';

import config from 'constants/Config';

export default ( { field, ...rest } ) => {
  return (
    <FormInput field={field}>
      {( { setValue, getValue, setTouched } ) =>
        <StarRatingComponent
          name={field}
          value={getValue()}
          onStarClick={( value ) => {
            setValue( value );
            setTouched()
          }}
          renderStarIcon={( e, t ) =>
             <span className="material-icons">{e <= t ? 'star' : 'star_border'}</span>
          }
          starColor={config.color.appYellow}
          {...rest}
        />
      }
    </FormInput>
  )
}



// WEBPACK FOOTER //
// ./components/FormElements/StarRate/index.js